import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import AccountSalesManageStaticsContainer from '../../containers/account-sales-manage-statics/AccountSalesManageStaticsContainer';

const AccountSalesManageViewPage = () => {
  return (
    <>
      <BreadcrumbsContainer
        title="결산관리/계정별 판매관리비 통계"
        icon="statistics"
      />
      <AccountSalesManageStaticsContainer />
    </>
  );
};

export default AccountSalesManageViewPage;
